// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__1_a0L","card":"Carousel_card__1WY3A"};